var done = true;
var shouldGlobalize = false
var globalstate = 0

// Handles open and close stuff.
export function initializeMenu() {
    var menuButton = document.getElementById('main-menu-button');

    // 0 = closed and 1 is open.
    var currentState = 0;

    menuButton.onclick = function () {
        if (shouldGlobalize) {
            shouldGlobalize = false
            currentState = globalstate
        }

        if (done == true) {
            openCloseAnim(currentState);

            if (currentState === 0) currentState = 1
            else currentState = 0
        }
    }
}

// Handles the open and close animation, Mainly the fading etc.
export function openCloseAnim(state) {
    var overlay = document.getElementsByClassName("header-overlay")[0];

    if (state === 0) {
        animateMenuButton(state);

        overlay.style.display = 'flex';
        window.setTimeout(function () {
            overlay.style.opacity += 1.0;
        }, 50);
    } else {
        animateMenuButton(state);

        window.setTimeout(function () {
            overlay.style.opacity = 0.0;
        }, 50);
        window.setTimeout(function () {
            overlay.style.display = 'none';
        }, 1050);
    }
}

// Animates the menubutton itself. Also used by search.js
export function animateMenuButton(state) {
    var row1 = document.getElementById('1');
    var row2 = document.getElementById('2');
    var row3 = document.getElementById('3');

    if (state === 0) {
        done = false;

        window.setTimeout(function () {
            row1.style.transform = 'translateY(13px)';
            row3.style.transform = 'translateY(-13px)';
        }, 50);

        window.setTimeout(function () {
            row1.style.transform += 'rotate(45deg)';
            row2.style.transform = 'scaleX(0)';
            row3.style.transform += 'rotate(-45deg)';
        }, 750);

        window.setTimeout(function () {
            done = true;
        }, 1200);
    } else {
        done = false;

        window.setTimeout(function () {
            row1.style.transform = 'rotate(0deg)';
            row1.style.transform += 'translateY(13px)';
            row2.style.transform = 'scaleX(1)';
            row3.style.transform = 'rotate(-0deg)';
            row3.style.transform += 'translateY(-13px)';
        }, 50);

        window.setTimeout(function () {
            row1.style.transform = 'translateY(0px)';
            row2.style.transform = 'scaleX(1)';
            row3.style.transform = 'translateY(0px)';
        }, 750);

        window.setTimeout(function () {
            done = true;
        }, 1050);
    }
}
export const setGlobalState = (number) => {
    shouldGlobalize = true
    globalstate = number
}
